<div id="divDropdown" class="dropdown-container">
  <h4>{{data.header}}</h4>
  <app-data-table
    [columns]="columns"
    [data]="rows"
    [pageSize]="rows.length || 10"
    (rowClick)="onSelected($event)">
    <ng-template appColumnCell="text" let-element>
      @if (! data.secondValue) {
        <label class="field__radio {{data.selected === element.Text ? 'radio-selected' : ''}}"><input type="radio" name="dropdownRadio" [checked]="data.selected === element.Text" /> {{element.Text}}</label>
      }
      @if (data.secondValue) {
        <label class="field__radio {{data.selected === element.code + '  ' + element.Text ? 'radio-selected' : ''}}"><input type="radio" name="dropdownRadio" [checked]="data.selected === element.code + '  '+ element.Text" /> <span>{{element.code}}</span>&nbsp;&nbsp;<span>{{element.description}}</span></label>
      }
    </ng-template>
  </app-data-table>
</div>
<mat-dialog-actions class="div-flex-buttons">
  <div class="div-flex-buttons"></div>
  <div>
    <div class="divclose">
      <button mat-dialog-close input type="button" [mat-dialog-close]="true" class="btn btn-primary">Close</button>
    </div>
  </div>
</mat-dialog-actions>
